
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PlusCircle } from "lucide-react";
import { Lab } from "@/services/universityService";

interface LabSelectorProps {
  labs: Lab[];
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  disabled?: boolean;
  onAddNew: () => void;
  universitySelected: boolean;
}

const LabSelector: React.FC<LabSelectorProps> = ({ 
  labs, 
  value, 
  onChange, 
  readOnly = false,
  disabled = false,
  onAddNew,
  universitySelected
}) => {
  return (
    <Select
      disabled={disabled || readOnly}
      onValueChange={onChange}
      value={value}
    >
      <SelectTrigger>
        <SelectValue placeholder={universitySelected ? "Select a lab" : "Select a university first"} />
      </SelectTrigger>
      <SelectContent>
        {labs.map((lab) => (
          <SelectItem key={lab.id} value={lab.id}>
            {lab.name}
          </SelectItem>
        ))}
        {!readOnly && universitySelected && (
          <SelectItem value="add_new" className="text-primary">
            <div className="flex items-center">
              <PlusCircle className="mr-2 h-4 w-4" />
              Add new lab
            </div>
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};

export default LabSelector;
